<template>
    <common-content-spacer height="small">
        <div class="register-physicians--profile__text">
            <div>{{ physicians.length }} {{ $t('pages.auth.signup.steps.register_physicians.already_registred') }} (</div>
            <div class="register-physicians--profile__number">
                {{ physiciansWithUncompleteProfileCount }}
            </div>
            <div>{{ $t('pages.auth.signup.steps.register_physicians.incomplete_profile') }} )</div>
        </div>

        <div class="register-physicians--profiles">
            <div v-for="index in 3" :key="index" @mouseover="dropdownMouseOver" @mouseleave="dropdownMouseLeave">
                <div v-if="physicians.length > index - 1" :class="iconClass(index, physicians[index - 1])">
                    <common-dropdown
                        class="register-physicians--dropdown"
                        :isOpen="isDropdownOpen[index - 1]"
                        :hasArrow="true"
                        bgColor="white"
                        arrowPositionY="bottom"
                        arrowPositionX="register-physician"
                    >
                        <complete-profile-check :physician="physicians[index - 1]"></complete-profile-check>
                    </common-dropdown>

                    <common-icon :name="signIcon(physicians[index - 1])" size="micro"></common-icon>
                </div>
                <div
                    v-if="physicians.length > index - 1"
                    :class="avatarClass(index)"
                    @mouseover="avatarMouseOver(index)"
                    @mouseleave="avatarMouseLeave(index)"
                >
                    <common-user-avatar :user="physicians[index - 1]" size="user-menu"></common-user-avatar>
                </div>
            </div>
            <div v-if="physicians.length > 3" class="register-physicians--profile__others" @click="toggleModal">
                + {{ physicians.length - 3 }}
            </div>
        </div>

        <complete-profile-modal
            v-if="showCompleteProfileModal"
            :physicians="physicians"
            @close="toggleModal"
        ></complete-profile-modal>
    </common-content-spacer>
</template>

<script>
    import UserRolesEnum from '../../../../enums/UserRolesEnum'
    import CompleteProfileModal from 'components/page-elements/auth/register-physicians/CompletePhysicianProfileModal'
    import CompleteProfileCheck from 'components/page-elements/auth/register-physicians/CompletePhysicianProfileCheck'

    export default {
        components: {
            CompleteProfileModal,
            CompleteProfileCheck,
        },

        data() {
            return {
                physicians: this.$auth.getMembers().filter((member) => member.userRole.id === UserRolesEnum.PHYSICIAN.ID),
                hoveredIconIndex: null,
                showCompleteProfileModal: false,
                isDropdownOpen: [false, false, false],
                isDropdownMouseOver: false,
            }
        },

        computed: {
            physiciansWithUncompleteProfileCount() {
                return this.physicians.filter((physician) => !physician.isAvailabilitySet).length
            },
        },

        methods: {
            signIcon(physician) {
                return physician.isAvailabilitySet ? 'small-white-check' : 'small-white-warning'
            },

            iconClass(index, physician) {
                return {
                    'register-physicians--profile__sign': true,
                    [`sign register-physicians--profile__sign__${index}`]: true,
                    [`sign register-physicians--profile__sign__${physician.isAvailabilitySet ? 'success' : 'warn'}`]: true,
                    'sign register-physicians--profile__sign__hovered': this.hoveredIconIndex && this.hoveredIconIndex === index,
                }
            },

            avatarClass(index) {
                return {
                    [`register-physicians--profile register-physicians--profile__${index}`]: true,
                    'register-physicians--profile register-physicians--profile__hovered': this.hoveredIconIndex === index,
                }
            },

            dropdownMouseOver() {
                this.isDropdownMouseOver = true
            },

            dropdownMouseLeave() {
                this.isDropdownMouseOver = false
                this.isDropdownOpen = this.isDropdownOpen.map(() => false)
                this.hoveredIconIndex = null
            },

            avatarMouseOver(index) {
                this.hoveredIconIndex = index
                this.openDropdown(index)
            },

            avatarMouseLeave(index) {
                if (!this.isDropdownMouseOver) {
                    this.closeDropdown(index)
                    this.hoveredIconIndex = null
                }
            },

            toggleModal() {
                this.showCompleteProfileModal = !this.showCompleteProfileModal
            },

            openDropdown(index) {
                this.isDropdownOpen[index - 1] = true
            },

            closeDropdown(index) {
                this.isDropdownOpen[index - 1] = false
            },
        },
    }
</script>
